<nb-card>
  <nb-card-header>
    <h6>{{ receiptDetail.productName }}</h6>
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <table class="table table-sm table-borderless tbl-receipt-summary">
      <tr>
        <td class="col-label">{{ "receipt.quantity" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <nb-form-field fullWidth>
              <button
                nbPrefix
                nbButton
                ghost
                (click)="productQuantityIncrement(-1)"
              >
                <nb-icon icon="minus-circle-outline"> </nb-icon>
              </button>
              <input
                type="number"
                nbInput
                fullWidth
                shape="semi-round"
                class="form-control"
                placeholder="Nhập số lượng"
                [status]="receiptDetail.quantity > 0 ? 'primary' : 'danger'"
                [(ngModel)]="receiptDetail.quantity"
                (change)="summaryReceiptDetail()"
              />
              <button
                nbSuffix
                nbButton
                ghost
                (click)="productQuantityIncrement(1)"
              >
                <nb-icon icon="plus-circle-outline"> </nb-icon>
              </button>
            </nb-form-field>
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "receipt.price" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập giá bán"
              [status]="receiptDetail.price > 0 ? 'primary' : 'danger'"
              [(ngModel)]="receiptDetail.price"
              (change)="summaryReceiptDetail()"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "receipt.amount" | translate }}:</td>
        <td class="col-number">
          <h6 class="text-primary">{{ receiptDetail.netAmount | number }}</h6>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "receipt.discount" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              type="number"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              style="width: 20px"
              min="0"
              max="100"
              placeholder="% ck"
              [(ngModel)]="receiptDetail.discountPercent"
              (change)="summaryReceiptDetail()"
            />

            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="$ ck"
              [status]="receiptDetail.discountAmount > 0 ? 'primary' : 'danger'"
              [(ngModel)]="receiptDetail.discountAmount"
              (change)="onInputDiscountAmountChange()"
              (keydown.enter)="onInputDiscountAmountChange()"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </td>
      </tr>
      <tr>
        <td class="col-label">
          <h6 class="text-hint">{{ "receipt.total" | translate }}:</h6>
        </td>
        <td class="col-number">
          <h6 class="text-danger">
            {{ receiptDetail.amount | number }}
          </h6>
        </td>
      </tr>

      <tr>
        <td colspan="2" class="col-label">
          <textarea
            nbInput
            fullWidth
            rows="2"
            placeholder="{{ 'receipt.inputNote' | translate }}"
            class="form-control"
            [(ngModel)]="receiptDetail.comment"
          ></textarea>
        </td>
      </tr>
    </table>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="primary"
      size="small"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
